<template>
  <div class="goods-detail-page" v-if="orderConfirmData">
    <van-nav-bar title="确认订单" left-arrow @click-left="$router.back()" fixed placeholder />

    <div class="order-details">
      <van-cell-group>
        <van-cell :title="orderConfirmData.shopName" :label="orderConfirmData.shopAddress" icon="location-o" />
      </van-cell-group>

      <div class="order-items">
        <div class="order-item" v-for="item in orderConfirmData.goodsInfo[0].items" :key="item.itemId">
          <img :src="item.skuInfo.productData.productImageUri" alt="" class="item-image" />
          <div class="item-info">
            <div class="item-name">{{ item.skuInfo.productData.productName }}</div>
            <div class="item-specs">{{ formatProductAttrs(item.productAttrList) }}</div>
          </div>
          <div class="item-price">
            <div class="count">￥{{ item.productPrice.actualPrice.amount }}</div>
          </div>
        </div>
      </div>

      <!-- 优惠券显示 -->
      <van-cell-group>
        <van-cell title="优惠券" :value="memberCoupon ? memberCoupon.couponName : '暂无优惠券'" />
      </van-cell-group>

      <van-cell-group title="订单备注">
        <van-field v-model="remark" rows="2" autosize type="textarea" maxlength="50" placeholder="请输入备注"
          show-word-limit />
      </van-cell-group>
    </div>

    <van-submit-bar button-text="下单" @submit="onSubmit" :loading="submitting" />

    <!-- 优惠券弹窗 -->
    <van-popup v-model="showCouponPopup" position="bottom" round closeable :style="{ height: '60%' }">
      <div class="coupon-popup">
        <div class="popup-title">优惠券</div>
        <div class="coupon-list" v-if="couponList.length > 0">
          <div v-for="coupon in couponList" :key="coupon.cardId" class="coupon-item" :class="{
            active: selectedCoupon && selectedCoupon.cardId === coupon.cardId,
          }" @click="selectCoupon(coupon)">
            <div class="coupon-content">
              <div class="coupon-name">{{ coupon.title }}</div>
            </div>
            <div class="coupon-checkbox">
              <van-checkbox :value="selectedCoupon && selectedCoupon.cardId === coupon.cardId
                " @click.stop />
            </div>
          </div>
        </div>
        <div class="no-coupon" v-else>暂无可用优惠券</div>
        <div class="popup-footer">
          <van-button type="primary" block @click="confirmCouponSelection">
            确定
          </van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import request from "@/utils/request";
import { mapState, mapGetters } from "vuex";
export default {
  name: "GoodsDetail",
  data() {
    return {
      orderInfo: null,
      orderConfirmData: null,
      orderKey: "",
      remark: "",
      showCouponPopup: false,
      couponList: [],
      selectedCoupon: null,
      submitting: false,
      gettingOrder: false,
    };
  },
  computed: {
    ...mapState(["appConfig", "uuid", "memberCoupon"]),
    ...mapGetters(["phoneNumber"]),
    couponDisplayText() {
      if (this.selectedCoupon) {
        return this.selectedCoupon.title;
      }
      if (this.couponList.length > 0) {
        return `${this.couponList.length}张可用`;
      }
      return "暂无可用";
    },
  },
  async created() {
    try {
      // 从路由参数获取店铺信息
      const shopId = this.$route.query.shopId;
      const customerShopCode = this.$route.query.customerShopCode;
      const shopName = this.$route.query.shopName;
      const shopAddress = this.$route.query.shopAddress;

      if (!shopId || !customerShopCode) {
        this.$toast("缺少店铺信息");
        return;
      }

      this.orderInfo = {
        shopId,
        customerShopCode,
        shopName,
        shopAddress,
      };

      await this.getOrderPreview();
    } catch (error) {
      this.$toast("加载订单失败");
      console.error(error);
    }
  },
  methods: {
    async getOrderPreview() {
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });

      try {
        const params = {
          channelCode: 20,
          brandId: 1,
          shopId: this.orderInfo.shopId,
          customerShopCode: this.orderInfo.customerShopCode,
          orderType: "1",
          deliveryType: "SELF_PICK",
          promotionList: [],
          priorityPromotionType: "COUPON",
          bindCalcFlag: true,
          paidCouponActivityId: "",
          autoRecommendPaidCoupon: false,
          invalidItemResp: true,
          v3: true,
          autoRecommendPromotion: true,
        };

        console.log("订单预览参数：", params);
        let response = await request.post("/gm/order-preview", params);

        if (response) {
          response = response.data;
        }

        console.log("订单预览返回：", response);

        if (response && response.order && response.order.code === 0) {
          const orderData = response.order.data;
          
          // 处理订单数据
          this.orderConfirmData = {
            shopName: orderData.orderShopData?.shopName || this.orderInfo.shopName,
            shopAddress: orderData.orderShopData?.address || this.orderInfo.shopAddress,
            goodsInfo: [{
              items: orderData.itemList || []
            }],
            priceData: orderData.priceData,
            produceData: orderData.produceData,
            orderShopData: orderData.orderShopData, // 保存完整的店铺数据
            districtCode: orderData.orderShopData?.districtCode || orderData.districtCode,
            deviceToken: orderData.deviceToken,
          };

          // 处理优惠券列表
          const couponDataV2 = orderData.couponDataV2 || {};
          const usableList = couponDataV2.usableList || [];
          const unusableList = couponDataV2.unusableList || [];
          
          this.couponList = [...usableList, ...unusableList];
          
          // 默认选中第一张可用优惠券
          if (usableList.length > 0) {
            this.selectedCoupon = usableList[0];
          }

          this.$toast.clear();
        } else {
          // 检查是否是购物车为空错误
          if (response?.order?.code === -100103006) {
            this.$toast.clear();
            this.$toast.fail(response.order.msg || '购物车商品为空，请刷新');
            // 延迟跳转回店铺列表页面
            setTimeout(() => {
              this.$router.push('/shop-list');
            }, 1500);
            return;
          }
          
          this.$toast.fail(response?.order?.msg || "获取订单预览失败");
        }
      } catch (error) {
        console.error("订单预览失败：", error);
        this.$toast.fail("订单预览失败");
      }
    },
    getErrorMessage(error) {
      if (!error) return '请求失败';
      if (typeof error === 'string') return error;
      if (error.message) return error.message;
      if (error.response && error.response.data) {
        const data = error.response.data;
        if (typeof data === 'string') return data;
        return data.message || data.msg || JSON.stringify(data);
      }
      try { return String(error); } catch (_) { return '请求失败'; }
    },
    buildRequiredList(coupon) {
      if (!coupon) return [];
      return [
        {
          id: coupon.templateId,
          name: coupon.title,
          preferentialType: 11,
          ruleEngineId: 0,
          couponList: [
            {
              couponId: coupon.cardId,
              couponName: coupon.title,
              couponTemplateId: coupon.templateId,
              id: coupon.templateId,
              preferentialType: 11,
              ruleEngineId: 0,
              platformType: 0,
            },
          ],
          promotionIndex: 6,
        },
      ];
    },
    async getOrderConfirm() {
      if (this.gettingOrder) return;
      this.gettingOrder = true;
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });

      try {
        const payload = {
          // ...this.orderInfo,
          shopId: this.orderInfo.shopId,
          paidCardVersion: 1,
          storeId: this.appConfig.storeId,
          addrId: "",
          buyerRemarks: this.remark,
          giftCardIds: [],
          depositGiftCardTemplateIdList: [],
          usedPointExchage: 0,
          poinDeduc: 0,
          joinOrderStar: -1,
          manualGiveUpStar: 0,
          tableId: "",
          isWaiterCheck: 0,
          reservePhone: "",
          orderActivitys: [],
          items: this.orderInfo.itemList, // 直接使用从上一页传来的itemList
          isUseFlavorCard: 0,
          selectConsumerBenefit: null,
          firstTime: true,
          // lng: "lSMdD/E3UFZq4HlNHsuNaayhcPYIOC8GepGdhlMqKWw=",
          // lat: "4WpixJayuOgVRHMeSGlYuhBdoEoiZI5Z4Ik2EvPWYrg=",
          appVersion: "5.85.0",
          eVersion: "1.0",
          appid: this.appConfig.appid,
          requiredList: [],
        };
        // 清理一下从orderInfo带过来的多余字段
        delete payload.itemList;

        if (this.appConfig.name == '益和堂') {
          payload['items'][0]["attachList"] = [
            {
              "id": "830097170393366528",
              "name": "默认糖",
              "num": 1
            }
          ]

        }

        console.log('payload', payload);



        const res = await request.post("/qimai/order/confirm", payload);
        if (res.code === "0") {
          this.orderConfirmData = res.data;
          this.orderConfirmData.shopName = this.orderInfo.shopName; // 从 orderInfo 中获取 shopName
          this.orderConfirmData.shopAddress = this.orderInfo.shopAddress; // 从 orderInfo 中获取 shopAddress

          if (this.couponList.length === 0) {
            this.couponList = res.data.crmCouponInfoList || [];
            if (this.couponList.length > 0) {
              this.couponList = res.data.crmCouponInfoList.filter(
                (item) => item.couponTemplate.id == this.appConfig.dataId
              );

              console.log("优惠卷列表", this.couponList);

              this.selectedCoupon = this.couponList[0];
              console.log(this.selectedCoupon);

            }
          }
        } else {
          this.$toast.fail(res.message || "加载失败");
        }
      } catch (error) {
        this.$toast.fail("请求失败");
        console.error(error);
      } finally {
        this.gettingOrder = false;
        this.$toast.clear();
      }
    },
    selectCoupon(coupon) {
      this.selectedCoupon = coupon;
    },
    confirmCouponSelection() {
      this.showCouponPopup = false;
    },
    async onSubmit() {
      if (this.submitting) return;
      this.submitting = true;

      this.$toast.loading({
        message: "创建订单中...",
        forbidClick: true,
        duration: 0,
      });

      try {
        // 构建优惠券列表
        const promotionList = [];
        if (this.selectedCoupon) {
          promotionList.push({
            promotionId: this.selectedCoupon.couponUserId,
            promotionType: "COUPON",
            level: 1,
            couponTemplateId: this.selectedCoupon.promotionId,
            paidCouponFlag: false
          });
        }

        // 构建古茗创建订单参数
        const payload = {
          uuid: this.uuid, // 链接UUID
          channelCode: 20,
          brandId: 1,
          shopId: this.orderInfo.shopId,
          receiveUserInfo: {
            phone: this.phoneNumber || "", // 从 orderId 中提取的手机号
            address: this.orderConfirmData.shopAddress || this.orderInfo.shopAddress,
          },
          customerShopCode: this.orderInfo.customerShopCode,
          orderType: "1",
          deliveryType: "SELF_PICK",
          promotionList: promotionList,
          priorityPromotionType: promotionList.length > 0 ? "COUPON" : "",
          priceData: this.orderConfirmData.priceData,
          remark: this.remark || "",
          isPack: false,
          bindCalcFlag: true,
          paidCouponActivityId: "",
          districtCode: this.orderConfirmData.districtCode || "440103",
          v3: true,
          deviceToken: this.orderConfirmData.deviceToken || "",
        };

        console.log("创建订单参数：", payload);

        let createOrderRes = await request.post('/gm/create-order', payload);
        
        if (createOrderRes) {
          createOrderRes = createOrderRes.data;
        }

        console.log("创建订单返回：", createOrderRes);

        // 兼容两种返回格式：order 和 orderInfo
        const orderResponse = createOrderRes?.order || createOrderRes?.orderInfo;
        
        if (orderResponse && orderResponse.code === 0) {
          const orderData = orderResponse.data;
          const orderId = orderData.orderId;
          const orderStatus = orderData.orderStatus;
          const payAmount = orderData.orderPayData?.payAmount?.amount;

          console.log("订单ID：", orderId);
          console.log("订单状态：", orderStatus);
          console.log("支付金额：", payAmount);

          this.$toast.clear();
          this.$toast.success("下单成功");

          // 跳转到订单详情页
          setTimeout(() => {
            this.$router.push({
              path: '/order-detail',
              query: {
                orderId: orderId,
              },
            });
          }, 1000);
        } else {
          this.$toast.clear();
          
          this.$toast.fail(orderResponse?.msg || createOrderRes?.message || '下单失败');
        }
      } catch (error) {
        this.$toast.clear();
        console.log("创建订单错误：", error);
        this.$toast.fail(this.getErrorMessage(error) || '下单请求失败');
        console.error(error);
      } finally {
        this.submitting = false;
      }
    },

    async callWeChatPaymentAPI(paymentData) {
      try {
        const reqDataObject = this.constructReqDataObject(
          paymentData,
          this.appConfig.appid
        );
        const weChatPayload = {
          appid: this.appConfig.appid,
          req_data: JSON.stringify(reqDataObject),
        };
        await request.post("/qimai/wx-payment-proxy", {
          sessionId: "37482d171094e75eb1661b09d3021062",
          payload: weChatPayload,
        });

        this.$router.push({
          path: "/order-detail",
          query: { orderNo: this.orderInfo.orderNo },
        });

        // if (res && res.uuid) {
        // 将 orderNo 挂载到 this.orderInfo 上，以便后续方法可以访问
        // this.orderInfo.orderNo = paymentData.out_trade_no;

        // this.triggerWeChatQRConnect(res.uuid);
        // } else {
        //   this.$toast.fail(res.err_msg || '获取支付凭证失败');
        // }
      } catch (error) {
        this.$toast.fail("支付代理请求失败");
        console.error("Payment proxy failed", error);
      }
    },

    async triggerWeChatQRConnect(uuid) {
      // this.$toast.loading({
      //   message: '请在微信中完成支付...',
      //   forbidClick: true,
      //   duration: 0,
      // });

      const maxRetries = 20; // 轮询20次，约1分钟
      let retries = 0;
      let lastStatus = -1;

      const poll = async () => {
        if (retries >= maxRetries) {
          this.$toast.fail("支付超时，请重试");
          return;
        }
        try {
          const res = await request.post("/qrconnect", {
            appid: this.appConfig.appid,
            uuid: uuid,
            last: lastStatus,
          });

          if (typeof res === "string") {
            if (res.includes("window.wx_code=200")) {
              this.$toast.success("支付成功！");
              // this.$router.push({
              //   path: '/order-detail',
              //   query: { orderNo: this.orderInfo.orderNo },
              // });
              return; // 支付成功，停止轮询
            }

            const errcodeMatch = res.match(/window.wx_errcode=(\d+)/);
            if (errcodeMatch) {
              const errcode = parseInt(errcodeMatch[1], 10);
              switch (errcode) {
                case 408: // 等待扫码（超时）
                  // 状态不变，继续轮询
                  break;
                case 404: // 已扫码，等待确认
                  this.$toast.loading({
                    message: "已扫码，请在手机上确认...",
                    forbidClick: true,
                    duration: 0,
                  });
                  break;
                case 405: // 已确认支付
                  this.$toast.success("支付成功！");
                  this.$router.push({
                    path: "/order-detail",
                    query: { orderNo: this.orderInfo.orderNo },
                  });
                  return; // 支付成功，停止轮询
                case 402: // 已取消
                case 403: // 二维码过期
                  this.$toast.fail("您已取消支付或二维码已过期");
                  return; // 停止轮询
                default:
                  this.$toast.fail(`支付失败，错误码: ${errcode}`);
                  return; // 停止轮询
              }
            }
          } else {
            this.$toast.fail("支付状态查询异常");
            console.error("QRConnect poll returned unexpected data", res);
            return; // 停止轮询
          }

          // 从返回的脚本中解析出 lastStatus 以用于下一次请求
          const match = res.match(/last\s*=\s*(\d+)/);
          if (match) {
            lastStatus = match[1];
          }

          retries++;
          setTimeout(poll, 3000); // 3秒后再次轮询
        } catch (error) {
          this.$toast.fail("支付状态查询失败");
          console.error("QRConnect poll failed", error);
        }
      };

      poll(); // 开始轮询
    },

    constructReqDataObject(paymentData, appid) {
      const args = {
        adUxInfo: "",
        timeStamp: paymentData.timeStamp,
        nonceStr: paymentData.nonceStr,
        package: paymentData.package_str, // 根据新的返回结构修改
        signType: paymentData.signType,
        paySign: paymentData.paySign,
        cookie: `busid=wxapp; appid=${appid};; busid=wxapp; sessionid=SessionId%403041182606_13%231752982620731;; busid=wxapp; scene=1256;; busid=wxapp; scene_note=gh_9e2dbe88a92b%40app%3B%3B%3B0`,
        grantMessageQuota: true,
        requestId: Math.floor(Math.random() * 1000),
        commonUxInfo: "",
      };

      const invokeData = {
        args: JSON.stringify(args),
        miniprogramAppID: appid,
        name: "requestPayment",
        title: "发起支付",
        isBridgedJsApi: true,
        transitiveData: "",
        jsapiType: "appservice",
      };

      const finalPayload = {
        runtimeTicket: "Test",
        runtimeSessionId: "5435d6eafa9fe9cce1eb905ca37aa548",
        pathType: 1,
        reportUuid: `SessionId@3041182606_13#${Date.now() - 5000
          }_${Date.now()}`,
        reportWxaLibVersion: "3.8.11",
        deviceName: "WIN-1TV2F4I65G6",
        deviceId: "00-10-FE-6F-45-88",
        devicePlatform: "windows",
        clientVersion: "1661537335",
        invokeData: JSON.stringify(invokeData),
      };

      return finalPayload; // 返回对象而非字符串
    },
    formatPractice(item) {
      // 现在从 skuInfo 中直接获取规格信息
      if (item.skuInfo) {
        return Object.values(item.skuInfo).join(" , ");
      }
      const specs = (item.orderItemSpecList || []).map(
        (spec) => spec.specValue
      );
      const practices = (item.practiceList || []).map((p) => p.value);
      return [...specs, ...practices].join(" , ");
    },
    formatProductAttrs(attrList) {
      // 格式化商品属性列表
      if (!attrList || attrList.length === 0) return '';
      
      return attrList.map(attr => {
        const attrValues = attr.attrValueList.map(v => v.attrValueName).join(',');
        return attrValues;
      }).join(' / ');
    },
  },
};
</script>

<style lang="scss" scoped>
.goods-detail-page {
  padding-bottom: 100px;
  background-color: #f7f8fa;
}

.order-details {
  margin-top: 12px;
}

.order-items {
  background-color: #fff;
  margin-bottom: 12px;
  padding: 0 12px;

  .order-item {
    display: flex;
    padding: 12px 0;
    border-bottom: 1px solid #f5f5f5;

    &:last-child {
      border-bottom: none;
    }
  }

  .item-image {
    width: 64px;
    height: 64px;
    border-radius: 8px;
    margin-right: 12px;
  }

  .item-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;

    .item-name {
      font-size: 16px;
      font-weight: 500;
    }

    .item-specs {
      font-size: 12px;
      color: #969799;
      margin-top: 4px;
    }
  }

  .item-price {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .count {
      font-size: 14px;
      color: #969799;
    }
  }
}

.van-cell-group {
  margin-bottom: 12px;
}

.van-submit-bar {
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.04);
}

.coupon-popup {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f7f8fa;

  .popup-title {
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    padding: 16px;
    background-color: #fff;
    position: relative;
  }

  .coupon-list {
    flex: 1;
    overflow-y: auto;
    padding: 12px;
  }

  .no-coupon {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #969799;
  }

  .coupon-item {
    display: flex;
    background: #fff;
    border-radius: 8px;
    margin-bottom: 12px;
    padding: 16px;
    position: relative;
    border: 1px solid #fff;
    align-items: center;

    &.active {
      border-color: #ee0a24;
    }
  }

  .coupon-content {
    flex: 1;

    .coupon-name {
      font-size: 16px;
      font-weight: 500;
      color: #323233;
    }

    .coupon-info {
      display: none; // 隐藏详细信息
    }
  }

  .coupon-checkbox {
    margin-left: 12px;
  }

  .popup-footer {
    padding: 12px 16px;
    background-color: #fff;
    border-top: 1px solid #f5f5f5;

    .van-button {
      height: 44px;
      border-radius: 22px;
      font-size: 16px;
    }
  }
}
</style>